import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);

interface IMarketItem
{
    id: any,
    fileUrl: string,
    imageUrl: string,
}
export type MarketResponseResponse =
{
    items: IMarketItem[]
}
export type DataverseType = IMarketItem;

/** Tiempo en ms que se reutiliza la respuesta de market-reports/enable (evita llamadas CONSTANTES desde el header). */
const MARKET_ENABLE_CACHE_MS = 15 * 60 * 1000;

class MenuService
{

    private _marketEnableCache: { value: boolean; at: number } | null = null;

    public getMarketItemEnable = async (): Promise<boolean> =>
    {
        const now = Date.now();
        if (this._marketEnableCache != null && (now - this._marketEnableCache.at) < MARKET_ENABLE_CACHE_MS)
        {
            return this._marketEnableCache.value;
        }
        try
        {
            const url: string = `${proxyUrl}/market-reports/enable`;
            const req = await axios.get<boolean>(url);
            const value = req.data === true;
            this._marketEnableCache = { value, at: now };
            return value;
        }
        catch
        {
            return false;
        }
    };
}

const news = new MenuService();
export default news;